export type PlacesBounds = { north: number; south: number; east: number; west: number };

const VICTORIA_CENTER = { lat: 28.798952, lng: -97.028503 };

export const VICTORIA_SERVICE_BOUNDS: PlacesBounds = {
	north: VICTORIA_CENTER.lat + 0.725,
	south: VICTORIA_CENTER.lat - 0.725,
	east: VICTORIA_CENTER.lng + 0.835,
	west: VICTORIA_CENTER.lng - 0.835
};

export function isWithinBounds(bounds: PlacesBounds, lat: number, lng: number): boolean {
	return lat <= bounds.north && lat >= bounds.south && lng <= bounds.east && lng >= bounds.west;
}
